import { IconPicker } from "../../../icons/IconPicker"
import { CardContentHeaderIconsProps } from "../../props/CardContentHeaderIconsProps"

export const CardContentHeaderIcons = ({
    icons,
    iconSize = 16,
    adjustedColor = "",
    isDirty = false
}: CardContentHeaderIconsProps) => {

    return (
        <div className="crd-icons">
            {icons && icons.map((icon, index) => (
                <div key={index}>
                    <IconPicker
                        icon={icon}
                        size={iconSize}
                        color={adjustedColor} />
                </div>
            ))}
            {
                isDirty &&
                <IconPicker
                    icon="asterisk"
                    size={16}
                    color="var(--card-dirty-color)" />
            }
        </div>
    )
}
